/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Endpoint_A_SdkInputs */

const en_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Install @getanyapi/sdk from npm for TypeScript or getanyapi from pip for Python. Both call every AnyAPI endpoint with the same key, and any HTTP client works too.`)
};

const zh_hans1_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有。TypeScript 用 npm 安装 @getanyapi/sdk，Python 用 pip 安装 getanyapi。两者都用同一个密钥调用所有 AnyAPI 接口，任何 HTTP 客户端也都可以。`)
};

const pt_br2_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Instale @getanyapi/sdk pelo npm para TypeScript ou getanyapi pelo pip para Python. Os dois chamam todos os endpoints da AnyAPI com a mesma chave, e qualquer cliente HTTP também funciona.`)
};

const es_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Instala @getanyapi/sdk desde npm para TypeScript o getanyapi desde pip para Python. Ambos llaman a todos los endpoints de AnyAPI con la misma clave, y también sirve cualquier cliente HTTP.`)
};

const fr_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Installez @getanyapi/sdk depuis npm pour TypeScript ou getanyapi depuis pip pour Python. Les deux appellent chaque endpoint AnyAPI avec la même clé, et n’importe quel client HTTP fonctionne aussi.`)
};

const de_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Installiere @getanyapi/sdk von npm für TypeScript oder getanyapi von pip für Python. Beide rufen jeden AnyAPI-Endpoint mit demselben Schlüssel auf, und jeder HTTP-Client funktioniert ebenfalls.`)
};

const ru_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да. Установите @getanyapi/sdk из npm для TypeScript или getanyapi из pip для Python. Оба вызывают любой эндпоинт AnyAPI с одним и тем же ключом, а ещё подойдёт любой HTTP-клиент.`)
};

const it_seo_endpoint_a_sdk = /** @type {(inputs: Seo_Endpoint_A_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Installa @getanyapi/sdk da npm per TypeScript o getanyapi da pip per Python. Entrambi chiamano ogni endpoint AnyAPI con la stessa chiave, e funziona anche qualsiasi client HTTP.`)
};

/**
* | output |
* | --- |
* | "Yes. Install @getanyapi/sdk from npm for TypeScript or getanyapi from pip for Python. Both call every AnyAPI endpoint with the same key, and any HTTP client ..." |
*
* @param {Seo_Endpoint_A_SdkInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_sdk = /** @type {((inputs?: Seo_Endpoint_A_SdkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_SdkInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_sdk(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_sdk(inputs)
	if (locale === "es") return es_seo_endpoint_a_sdk(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_sdk(inputs)
	if (locale === "de") return de_seo_endpoint_a_sdk(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_sdk(inputs)
	if (locale === "it") return it_seo_endpoint_a_sdk(inputs)
	return en_seo_endpoint_a_sdk(inputs)
});